module.exports = __webpack_public_path__ + "img/close-icon.8dd7f9a0.svg";